type TimezoneOption = { value: string; label: string };

export const extendedTimezones: TimezoneOption[] = [
  // --- North America ---
  { value: "America/Adak", label: "(UTC-10:00) Hawaii-Aleutian" },
  { value: "Pacific/Honolulu", label: "(UTC-10:00) Hawaii" },
  { value: "America/Anchorage", label: "(UTC-09:00) Alaska" },
  { value: "America/Los_Angeles", label: "(UTC-08:00) Pacific Time (US & Canada)" },
  { value: "America/Tijuana", label: "(UTC-08:00) Tijuana, Baja California" },
  { value: "America/Denver", label: "(UTC-07:00) Mountain Time (US & Canada)" },
  { value: "America/Phoenix", label: "(UTC-07:00) Arizona" },
  { value: "America/Mazatlan", label: "(UTC-07:00) Chihuahua, La Paz, Mazatlan" },
  { value: "America/Chicago", label: "(UTC-06:00) Central Time (US & Canada)" },
  { value: "America/Mexico_City", label: "(UTC-06:00) Guadalajara, Mexico City, Monterrey" },
  { value: "America/Regina", label: "(UTC-06:00) Saskatchewan" },
  { value: "America/New_York", label: "(UTC-05:00) Eastern Time (US & Canada)" },
  { value: "America/Bogota", label: "(UTC-05:00) Bogota, Lima, Quito" },
  { value: "America/Indiana/Indianapolis", label: "(UTC-05:00) Indiana (East)" },
  { value: "America/Halifax", label: "(UTC-04:00) Atlantic Time (Canada)" },
  { value: "America/St_Johns", label: "(UTC-03:30) Newfoundland" },

  // --- South America ---
  { value: "America/Caracas", label: "(UTC-04:00) Caracas, La Paz" },
  { value: "America/Santiago", label: "(UTC-04:00) Santiago" },
  { value: "America/Argentina/Buenos_Aires", label: "(UTC-03:00) Buenos Aires, Georgetown" },
  { value: "America/Sao_Paulo", label: "(UTC-03:00) Brasilia" },
  { value: "America/Montevideo", label: "(UTC-03:00) Montevideo" },

  // --- Atlantic & Europe ---
  { value: "Atlantic/South_Georgia", label: "(UTC-02:00) Mid-Atlantic" },
  { value: "Atlantic/Azores", label: "(UTC-01:00) Azores" },
  { value: "Atlantic/Cape_Verde", label: "(UTC-01:00) Cape Verde Is." },
  { value: "UTC", label: "(UTC+00:00) Universal Time Coordinated" },
  { value: "Europe/London", label: "(UTC+00:00) London, Edinburgh, Dublin, Lisbon" },
  { value: "Europe/Paris", label: "(UTC+01:00) Central European Time (Paris, Berlin, Rome, Madrid)" },
  { value: "Europe/Warsaw", label: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb" },
  { value: "Europe/Athens", label: "(UTC+02:00) Eastern European Time (Athens, Bucharest)" },
  { value: "Europe/Helsinki", label: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius" },
  { value: "Europe/Moscow", label: "(UTC+03:00) Moscow, St. Petersburg, Volgograd" },

  // --- Africa & Middle East ---
  { value: "Africa/Casablanca", label: "(UTC+01:00) Casablanca" },
  { value: "Africa/Cairo", label: "(UTC+02:00) Cairo" },
  { value: "Africa/Johannesburg", label: "(UTC+02:00) Harare, Pretoria" },
  { value: "Asia/Jerusalem", label: "(UTC+02:00) Jerusalem" },
  { value: "Asia/Amman", label: "(UTC+03:00) Amman" },
  { value: "Asia/Riyadh", label: "(UTC+03:00) Kuwait, Riyadh" },
  { value: "Africa/Nairobi", label: "(UTC+03:00) Nairobi" },
  { value: "Asia/Tehran", label: "(UTC+03:30) Tehran" },
  { value: "Asia/Dubai", label: "(UTC+04:00) Abu Dhabi, Muscat" },
  { value: "Asia/Baku", label: "(UTC+04:00) Baku, Tbilisi, Yerevan" },
  { value: "Asia/Kabul", label: "(UTC+04:30) Kabul" },

  // --- Asia ---
  { value: "Asia/Karachi", label: "(UTC+05:00) Islamabad, Karachi, Tashkent" },
  { value: "Asia/Yekaterinburg", label: "(UTC+05:00) Yekaterinburg" },
  { value: "Asia/Kolkata", label: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi" },
  { value: "Asia/Kathmandu", label: "(UTC+05:45) Kathmandu" },
  { value: "Asia/Dhaka", label: "(UTC+06:00) Astana, Dhaka" },
  { value: "Asia/Almaty", label: "(UTC+06:00) Almaty, Novosibirsk" },
  { value: "Asia/Yangon", label: "(UTC+06:30) Yangon (Rangoon)" },
  { value: "Asia/Bangkok", label: "(UTC+07:00) Bangkok, Hanoi, Jakarta" },
  { value: "Asia/Krasnoyarsk", label: "(UTC+07:00) Krasnoyarsk" },
  { value: "Asia/Shanghai", label: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi" },
  { value: "Asia/Singapore", label: "(UTC+08:00) Kuala Lumpur, Singapore" },
  { value: "Asia/Taipei", label: "(UTC+08:00) Taipei" },
  { value: "Asia/Irkutsk", label: "(UTC+08:00) Irkutsk, Ulaanbaatar" },
  { value: "Asia/Tokyo", label: "(UTC+09:00) Osaka, Sapporo, Tokyo" },
  { value: "Asia/Seoul", label: "(UTC+09:00) Seoul" },

  // --- Australia & Pacific ---
  { value: "Australia/Darwin", label: "(UTC+09:30) Darwin" },
  { value: "Australia/Adelaide", label: "(UTC+09:30) Adelaide" },
  { value: "Australia/Sydney", label: "(UTC+10:00) Canberra, Melbourne, Sydney" },
  { value: "Australia/Brisbane", label: "(UTC+10:00) Brisbane" },
  { value: "Australia/Hobart", label: "(UTC+10:00) Hobart" },
  { value: "Asia/Vladivostok", label: "(UTC+10:00) Vladivostok" },
  { value: "Asia/Magadan", label: "(UTC+11:00) Magadan, Solomon Is., New Caledonia" },
  { value: "Pacific/Auckland", label: "(UTC+12:00) Auckland, Wellington" },
  { value: "Pacific/Fiji", label: "(UTC+12:00) Fiji, Kamchatka, Marshall Is." },
  { value: "Pacific/Tongatapu", label: "(UTC+13:00) Nuku'alofa" },
  { value: "Pacific/Kiritimati", label: "(UTC+14:00) Kiritimati" }
] ;

export default extendedTimezones;